import { Link } from "@tanstack/react-router";
import { BrandLogo } from "@/components/BrandLogo";

const messages: Record<string, { title: string; body: string; error?: boolean }> = {
  connected: {
    title: "GitHub connected",
    body: "The installation is ready. Return to Rivets to choose a repository.",
  },
  "error-claimed": {
    title: "Installation already connected",
    body: "That GitHub installation belongs to another Rivets organization.",
    error: true,
  },
  "error-verification": {
    title: "GitHub verification failed",
    body: "Rivets could not verify this installation. Return to the app and try again.",
    error: true,
  },
  verify: {
    title: "Return to the Rivets app",
    body: "Open the Rivets app on this device to finish connecting. The app confirms it started this connection before anything is saved.",
  },
  "error-binding": {
    title: "Connection not completed",
    body: "This connection was started somewhere else. Start it again from Rivets settings.",
    error: true,
  },
  "error-not-installer": {
    title: "Installation not connected",
    body: "Only the GitHub user who installed the Rivets app, or the owner of that personal account, can connect this installation.",
    error: true,
  },
  "error-already-connected": {
    title: "Organization already connected",
    body: "This Rivets organization is connected to a different GitHub installation. Uninstall that one on GitHub first.",
    error: true,
  },
  "error-not-configured": {
    title: "GitHub is not configured",
    body: "The server is missing GitHub authorization credentials.",
    error: true,
  },
};

export function GitHubConnectedPage() {
  const result = new URLSearchParams(window.location.search).get("github") ?? "error-verification";
  const message = messages[result] ?? messages["error-verification"]!;

  return (
    <main className="auth-shell">
      <section className="auth-card" aria-live="polite">
        <BrandLogo className="auth-logo" size={22} />
        <div className="panel" style={{ textAlign: "center", padding: 24 }}>
          <div
            aria-hidden="true"
            style={{
              width: 38,
              height: 38,
              margin: "0 auto 16px",
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              border: `1px solid ${message.error ? "var(--danger)" : "var(--success)"}`,
              color: message.error ? "var(--danger)" : "var(--success)",
              fontSize: "var(--glyph-xl)",
            }}
          >
            {message.error ? "!" : "✓"}
          </div>
          <h1 className="auth-title" style={{ marginBottom: 8 }}>{message.title}</h1>
          <p className="auth-subtitle" style={{ margin: "0 auto 20px", maxWidth: 340 }}>{message.body}</p>
          <Link className="btn btn-primary btn-block" to="/">Open Rivets app</Link>
        </div>
      </section>
    </main>
  );
}
